<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>

      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                  :clearable="true"
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="shopList"
                label="Select Shop"
                v-model="queryParams.shopId"
                item-text="name"
                item-value="id"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete
                v-model="queryParams.customerIds"
                :items="selectedCustomerList"
                label="Customer"
                @click="showCustomers()"
                item-text="code"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
            <v-spacer></v-spacer>
            <v-icon @click="show = !show" class="white--text">{{
              show ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</v-icon>
          </v-card-title>
          <v-card-text class="font-weight-bold" v-show="show">
            <v-layout row>
              <v-flex sm2 pt-3>Advanced Amount :</v-flex>
              <v-flex pt-3 sm2 style="text-align: right; padding-right: 25px">{{
                totalAdvancedAmount | decFormat
              }}</v-flex>
              <v-flex sm2
                ><v-btn
                  color="primary"
                  :loading="buttonLoading"
                  @click="showDetail('Advanced')"
                  >Detail</v-btn
                ></v-flex
              >
            </v-layout>
            <v-layout row>
              <v-flex sm2 pt-3>Advanced Sale Amount :</v-flex>
              <v-flex pt-3 sm2 style="text-align: right; padding-right: 25px">{{
                totalAdvancedSale | decFormat
              }}</v-flex>
              <v-flex sm2
                ><v-btn
                  color="primary"
                  :loading="buttonLoading"
                  @click="showDetail('Advanced Sale')"
                  >Detail</v-btn
                ></v-flex
              >
            </v-layout>
            <v-layout row>
              <v-flex sm2 pt-3>Net Amount :</v-flex>
              <v-flex sm2 pt-3 style="text-align: right; padding-right: 25px">{{
                netAmount | decFormat
              }}</v-flex>
              <v-flex sm2> </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <summary report> -->
    <div
      id="printReport"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Advanced Report [{{ detailType }}]
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Date From: [{{ queryParams.fromDate }}] To: [{{ queryParams.toDate }}]
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Reported Date: [{{ currentDate }}]
        </p>
      </div>
      <br />
      <div style="text-align: left">
        <p
          style="font-size: 15px; margin: 1px; font-weight: bold"
          v-if="detailType == 'Advanced'"
        >
          {{ detailType }} Amount : {{ totalAdvancedAmount | decFormat }}
        </p>
        <p
          style="font-size: 15px; margin: 1px; font-weight: bold"
          v-if="detailType == 'Advanced Sale'"
        >
          {{ detailType }} Amount : {{ totalAdvancedSale | decFormat }}
        </p>
      </div>
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">Date</th>
              <th style="border: 1px solid black; text-align: center">
                Ref No
              </th>
              <th style="border: 1px solid black; text-align: center">
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in detailprintList" :key="i">
              <td style="border: 1px solid black; text-align: left">
                {{ item.issueDateInMilliSecond | format-ms-date }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.refNo }}
              </td>
              <td
                style="
                  border: 1px solid black;
                  text-align: right;
                  padding-right: 50px;
                "
              >
                {{ item.amount | decFormat }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- detail list dialog -->
    <v-dialog v-model="showDetailListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-btn
            color="primary"
            :loading="buttonLoading"
            @click="detailPrintAll('printReport')"
            >Print All</v-btn
          >
          <v-btn
            color="success"
            :loading="exportButtonLoading"
            @click="detailExportAll()"
            >Export All</v-btn
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Supplier List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="detailList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td>
                    {{
                      props.item.issueDateInMilliSecond | format-ms-date
                    }}
                  </td>
                  <td>{{ props.item.refNo }}</td>
                  <td style="text-align: right; padding-right: 50px">
                    {{ props.item.amount | decFormat }}
                  </td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End dialog -->

    <!-- Customer list dialog -->
    <v-dialog v-model="showCustomerListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Name"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-btn outline color="primary" @click="onSearchCustomer">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="customerHeader"
                :items="customerList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="customerTotalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="customerPagination"
                :must-sort="true"
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th>
                      <v-checkbox
                        primary
                        hide-details
                        @click.native="toggleAll"
                        :input-value="props.all"
                        :indeterminate="props.indeterminate"
                      ></v-checkbox>
                    </th>
                    <th v-for="header in props.headers" :key="header.text">
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <td>
                    <v-checkbox
                      primary
                      hide-details
                      :input-value="props.selected"
                      :value="props.item"
                      :indeterminate="props.indeterminate"
                      v-model="selectedCustomerList"
                      multiple
                    ></v-checkbox>
                  </td>
                  <td>
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.address }}</td>
                  <td>{{ props.item.advancedAmount | decFormat }}</td>
                  <td>{{ props.item.creditLevel.name }}</td>
                  <td>
                    <v-icon
                      v-if="props.item.status == 'ACTIVE'"
                      medium
                      color="green"
                      >check_circle</v-icon
                    >
                    <v-icon v-else medium color="red">cancel</v-icon>
                  </td>
                </template>
              </v-data-table>
              <div class="text-xs-right">
                <v-btn color="primary" @click="setCustomer">Ok</v-btn>
              </div>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { commonService } from "../../services/common-service";
import { advancedReportService } from "../../services/advanced-report-service";
import { shopService } from "../../services/shop-service";
import { customerService } from "../../services/customer-service";

export default {
  name: "AdvancedReport",
  components: {},

  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    buttonLoading: false,
    exportButtonLoading: false,
    showDetailListDialog: false,
    showFilters: false,
    show: false,
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true,
      },
      {
        text: "General Reports",
        disabled: true,
      },
      {
        text: "Advanced Report",
        disabled: true,
      },
    ],
    headers: [
      { text: "Date", align: "left", value: "issueDate" },
      { text: "Ref No", align: "left", value: "refNo" },
      { text: "Amount", align: "center", value: "amount" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "",
      totalItems: 0,
    },
    totalRows: 0,
    queryParams: {
      fromDate: "",
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      shopId: "",
      customerIds: [],
    },
    customerQueryParams: {
      code: "",
      name: "",
      township: "",
      creditLevelId: "",
      status: "",
    },
    customerPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "code",
      totalItems: 0,
    },
    customerHeader: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Address", value: "address" },
      { text: "Advanced Amount", value: "advancedAmount" },
      { text: "Credit Level", value: "creditLevel", sortable: false },
      { text: "Status", value: "status", sortable: false },
    ],
    showCustomerListDialog: false,
    showCustomerListLoading: false,
    customerTotalRows: 0,
    shopList: [],
    currentDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
    decimalFormat: "",
    clonequeryParams: new Object(),
    totalAdvancedAmount: 0.0,
    totalAdvancedSale: 0.0,
    netAmount: 0.0,
    detailType: "",
    detailList: [],
    detailprintList: [],
    selectedCustomerList: [],
    customerList: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getDetailList();
      },
      deep: true,
    },
    customerPagination: {
      handler() {
        this.getCustomerList();
      },
      deep: true,
    },
  },

  created() {
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.queryParams.shopId = this.user.shopId;
    }
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.decimalFormat = commonService.formatdecimal();
    this.getShopList();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "advanced-report",
        query: this.queryParams,
      });
      this.getAdvancedReportSummary();
      this.clonequeryParams = JSON.parse(JSON.stringify(this.queryParams));
    },
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getAdvancedReportSummary() {
      this.showListLoading = true;
      advancedReportService
        .getAdvancedReportSummary(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.totalAdvancedAmount = res.data.totalAdvancedAmount;
            this.totalAdvancedSale = res.data.totalAdvancedSale;
            this.netAmount = res.data.netAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    showDetail(detailType) {
      this.detailType = detailType;
      this.getDetailList().then(
        (this.showDetailListDialog = !this.showDetailListDialog)
      );
    },
    getDetailList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      if (this.detailType == "Advanced") {
        return advancedReportService
          .getAdvancedAmountDetail(
            this.clonequeryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            if (res.data) {
              this.detailList = res.data.netSaleReportList;
              this.totalRows = res.data.totalElements;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      } else if (this.detailType == "Advanced Sale") {
        return advancedReportService
          .getAdvancedSaleAmountDetail(
            this.clonequeryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            if (res.data) {
              this.detailList = res.data.netSaleReportList;
              this.totalRows = res.data.totalElements;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      }
    },

    detailPrintAll(divName) {
      this.reprintReport().finally(() => {
        var printContents = document.getElementById(divName).innerHTML;
        var reprintWindow = window.open(
          "",
          "MsgWindow",
          "width=500,height=500"
        );
        reprintWindow.document.write(printContents);
        setTimeout(() => {
          reprintWindow.print();
          reprintWindow.close();
        }, 600);
        this.buttonLoading = false;
      });
    },

    detailExportAll() {
      this.exportButtonLoading = true;
      advancedReportService
        .getAdvancedReportDetailExport(this.clonequeryParams, this.detailType)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.exportButtonLoading = false;
        });
    },
    showCustomers() {
      // Clean query params
      this.customerQueryParams.code = "";
      this.customerQueryParams.name = "";
      this.customerQueryParams.township = "";
      this.customerQueryParams.creditLevelId = "";
      this.customerQueryParams.status = "";
      this.selectedCustomerList = [];
      this.queryParams.customerIds = [];
      this.getCustomerList().then(
        (this.showCustomerListDialog = !this.showProductListDialog)
      );
    },
    setCustomer() {
      if (this.selectedCustomerList.length) {
        this.queryParams.customerIds = [];
        this.selectedCustomerList.forEach((element) => {
          if (!this.queryParams.customerIds.includes(element.id))
            this.queryParams.customerIds.push(element.id);
        });
      }
      this.showCustomerListDialog = !this.showCustomerListDialog;
    },
    toggleAll() {
      if (this.selectedCustomerList.length) {
        this.selectedCustomerList = [];
      } else {
        this.selectedCustomerList = this.customerList.slice();
      }
    },
    getCustomerList() {
      this.showCustomerListLoading = true;
      let order = this.customerPagination.descending ? "desc" : "asc";
      return customerService
        .getCustomers(
          this.customerQueryParams,
          this.customerPagination.page,
          this.customerPagination.rowsPerPage,
          this.customerPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.customerList = res.data.customerList;
            this.customerTotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showCustomerListLoading = false;
        });
    },
    onSearchCustomer() {
      this.customerQueryParams.page = this.customerPagination.page;
      this.customerQueryParams.size = this.customerPagination.rowsPerPage;
      this.getCustomerList();
    },

    reprintReport() {
      this.buttonLoading = true;
      if (this.detailType == "Advanced") {
        return advancedReportService
          .getAllAdvancedAmountDetail(this.clonequeryParams)
          .then((res) => {
            this.detailprintList = res.data.netSaleReportList;
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (this.detailType == "Advanced Sale") {
        return advancedReportService
          .getAllAdvancedSaleAmountDetail(this.clonequeryParams)
          .then((res) => {
            this.detailprintList = res.data.netSaleReportList;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
};
</script>